import React from 'react'
import { PlayerProfilePage } from './PlayerProfilePage'

interface PlayerProfileModalProps {
  playerId: number
  onClose: () => void
}

/**
 * Modal showing detailed player profile.
 * Used when clicking player names across the app (HistoricalFixtureModal, FixtureCard, etc.)
 *
 * This component now renders the full-featured PlayerProfilePage with:
 * - Tabs (Profile, Matches, Stats, Career)
 * - Bio grid, league stats, radar chart, position map
 * - Trophies, transfers, market value history
 * - Offline support with IndexedDB caching
 * - Stale data indicators
 */
export function PlayerProfileModal({
  playerId,
  onClose,
}: PlayerProfileModalProps) {
  return <PlayerProfilePage playerId={playerId} onClose={onClose} />
}
